import { updateAttributesOfCdnImage } from '@admin-panel/utils';
import type { LookGroupDTOType, LookGroupLookDTOType } from '../../../../schemas/styling';
import type { LookGroupListItem } from './types';

export const getGroupLookTitle = (look: LookGroupLookDTOType): string =>
  look.look_name || look.look_hook || `Look #${look.id}`;

export const getOptimizedSquareImage = (url?: string, size = 240) =>
  updateAttributesOfCdnImage(url, {
    width: size,
    height: size,
    quality: 100,
  }) || url;

export const sortLookGroups = (groups: Array<LookGroupDTOType>): Array<LookGroupDTOType> =>
  [...groups].sort((first, second) => {
    if (first.is_pinned !== second.is_pinned) {
      return first.is_pinned ? -1 : 1;
    }

    if (first.display_order !== second.display_order) {
      return first.display_order - second.display_order;
    }

    return second.id - first.id;
  });

export const toLookGroupListItem = (group: LookGroupDTOType): LookGroupListItem => {
  const primaryLook = group.primary_look;

  if (!primaryLook) {
    return { group, preview: null };
  }

  return {
    group,
    preview: {
      id: primaryLook.id,
      title: getGroupLookTitle(primaryLook),
      qcStatus: primaryLook.qc_status,
      lkStyleNumber: primaryLook.lk_style_number ?? undefined,
      imageUrl:
        primaryLook.image || primaryLook.generated_image_url || primaryLook.source_image_url,
    },
  };
};

export const isPublishedQcStatus = (qcStatus?: string | null) => qcStatus === 'published';
